var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal i8-modal", class: { "is-active": _vm.isOpen } },
    [
      _c("div", { staticClass: "modal-background" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal-card i8-modal__card",
          class: {
            "i8-modal--wide": _vm.getOption("width") == "wide",
            "i8-modal--medium": _vm.getOption("width") == "medium",
            "i8-modal--auto": _vm.getOption("width") == "auto"
          }
        },
        [
          _c("div", { staticClass: "modal-content i8-modal__content" }, [
            _vm.title != ""
              ? _c("header", { staticClass: "modal-card-head" }, [
                  _c("p", { staticClass: "modal-card-title" }, [
                    _vm._v(_vm._s(_vm.title))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isSlotEmpty("i8-modal-body")
              ? _c(
                  "section",
                  { staticClass: "modal-card-body" },
                  [_vm._t("i8-modal-body")],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isSlotEmpty("i8-modal-footer")
              ? _c(
                  "footer",
                  { staticClass: "modal-card-foot" },
                  [_vm._t("i8-modal-footer")],
                  2
                )
              : _vm._e()
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54cde9b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54cde9b1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./shared/components/I8Modal.vue
// module id = vkwY
// module chunks = 0 1